export type RequestType = 'feedback' | 'escalation' | 'appreciation' | 'solution-story' | 'public-testimonial' | null;
export type LevelType = 'project' | 'individual' | null;
/** Who raised the escalation (project-level form). */
export type EscalatedBySource = '' | 'client' | 'searce';

export interface FormData {
  // Project Selection Fields
  businessUnit: string;
  projectCode: string;
  accountName: string;
  opportunity: string;
  opportunityProjectOwner: string;
  /** Project owner email from tracker (with owner name); not the submitter */
  opportunityProjectOwnerEmail: string;
  workload: string; // For Solution Story form
  deliverySubBu: string; // Delivery Sub BU for Solution Story form
  // Email Sending Fields
  projectTitle: string;
  customerContactName: string;
  closureReport: File | null;
  toEmails: string;
  ccEmails: string;
  // Solution Story specific fields
  solutionProvided: string; // Max 70 characters
  keyObjectivesChallenges: string; // Min 400 characters (no max)
  executiveSummary: string; // Max 150 characters
  challengesChangedSinceInception: string; // Min 250 characters (no max)
  solutionDescription: string; // Min 400 characters (no max)
  practice: string; // Practice dropdown (maps to slide icon)
  platform: string[]; // Platform multi-select: GCP, Google Maps, AWS, Google Workspace
  platformUsageWay: string; // Min 100 characters (no max)
  businessContext: string[]; // Array of 4 strings, min 3 filled, total max 358 chars
  solution: string[]; // Array of 4 strings, min 3 filled, total max 358 chars
  impact: string[]; // Array of 4 strings, min 3 filled, total max 358 chars
  detailedSolutionImpact: string; // Min 400 characters (no max)
  techStack: string[]; // Dynamic array, min 1 filled, max 6 items
  techUsageWay: string; // Min 100 characters (no max)
  referencable: string; // R = referenceable, NR = non-referencable
  industryGroup: string; // Industry Group dropdown
  industry: string; // Industry text field
  teamworkCollaboration: string; // Teamwork & Collaboration (optional)
  resultsBusinessImpact: string; // Results & Business Impact (optional)
  solutionStoryFiles: File[]; // Multiple files for Solution Story form
  // Public Testimonial specific fields
  customerPocName: string; // Customer POC Name (required)
  customerPocDesignation: string; // Customer POC Designation (required)
  dateTestimonyReceived: string; // Date Testimony Received (date)
  publicTestimonialLink: string; // Link to the Public Testimonial (required)
  publicTestimonialFile: File | null; // Upload supporting documents (Max 1)
  // Other fields (for escalation and appreciation)
  customerSpocName: string;
  customerSpocDesignation: string;
  projectOwnerName: string;
  projectMemberName: string;
  feedbackSnippet: string;
  appreciationFile: File | null; // For Customer Appreciation form file upload
  email: string;
  customerName: string;
  feedbackType: string;
  category: string;
  feedbackDetails: string;
  rating: number | null;
  escalatedBySource: EscalatedBySource;
  escalatedByName: string;
  escalatedByDesignation: string;
  issueDescription: string;
  areaOfEscalation: string;
  areaOfEscalationOther: string;
  dateRaised: string;
  dateResolved: string;
  solutionProposed: string;
  rootCause: string;
  learnings: string;
}

export const initialFormData: FormData = {
  // Project Selection Fields
  businessUnit: '',
  projectCode: '',
  accountName: '',
  opportunity: '',
  opportunityProjectOwner: '',
  opportunityProjectOwnerEmail: '',
  workload: '',
  deliverySubBu: '',
  // Email Sending Fields
  projectTitle: '',
  customerContactName: '',
  closureReport: null,
  toEmails: '',
  ccEmails: '',
  // Solution Story specific fields
  solutionProvided: '',
  keyObjectivesChallenges: '',
  executiveSummary: '',
  challengesChangedSinceInception: '',
  solutionDescription: '',
  practice: '',
  platform: [],
  platformUsageWay: '',
  businessContext: ['', '', '', ''],
  solution: ['', '', '', ''],
  impact: ['', '', '', ''],
  detailedSolutionImpact: '',
  techStack: [''],
  techUsageWay: '',
  referencable: '',
  industryGroup: '',
  industry: '',
  teamworkCollaboration: '',
  resultsBusinessImpact: '',
  solutionStoryFiles: [],
  // Public Testimonial specific fields
  customerPocName: '',
  customerPocDesignation: '',
  dateTestimonyReceived: '',
  publicTestimonialLink: '',
  publicTestimonialFile: null,
  // Other fields
  customerSpocName: '',
  customerSpocDesignation: '',
  projectOwnerName: '',
  projectMemberName: '',
  feedbackSnippet: '',
  appreciationFile: null,
  email: '',
  customerName: '',
  feedbackType: '',
  category: '',
  feedbackDetails: '',
  rating: null,
  escalatedBySource: '',
  escalatedByName: '',
  escalatedByDesignation: '',
  issueDescription: '',
  areaOfEscalation: '',
  areaOfEscalationOther: '',
  dateRaised: '',
  dateResolved: '',
  solutionProposed: '',
  rootCause: '',
  learnings: '',
};

export interface SubmissionError {
  stage: 'upload' | 'submission' | 'email' | null;
  message: string;
  details?: string;
  ticketId?: string;
}
